import { lazy } from 'react'

import { PATH_NEW_LOADER } from 'config/paths'

export const SurveyRoutes = [
    {
        id: 1,
        module: 'loader-survey',
        protected: false,
        exact: true,
        path: PATH_NEW_LOADER.pages.survey,
        component: lazy(
            () =>
                import(
                    'containers/emulator/pages/survey/survey-page/SurveyPage'
                ),
        ),
    },
    {
        id: 2,
        module: 'loader-survey',
        protected: false,
        exact: true,
        path: `${PATH_NEW_LOADER.pages.survey}/:id`,
        component: lazy(
            () =>
                import(
                    'containers/emulator/pages/survey/survey-item/SurveyItem'
                ),
        ),
    },
]
